export default {
    'ERROR-ADD-HELPERS-AMBASSADORS': {
        'USER-ALREADY-IN-CAMPAIGN': {
            actionType: 'toast',
            message: {
                fr: "Un ou plusieurs ambassadeurs sont déjà ajoutés à cette campagne.",
                en: 'One or more ambassadors are already in this campaign.',
            },
        },
    },
};
